var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6579 12.8064C12.9711 12.6793 13.24 12.5143 13.4751 12.3008C14.5 11.3682 14.5 9.86746 14.5 6.86604C14.5 3.86529 14.5 2.36458 13.4751 1.43262C12.4494 0.5 10.8003 0.5 7.5 0.5C4.20042 0.5 2.54989 0.5 1.52495 1.43262C0.5 2.36524 0.5 3.86529 0.5 6.86604C0.5 9.8668 0.5 11.3675 1.52495 12.3001C1.76074 12.5137 2.02895 12.6786 2.34211 12.8057",
    stroke: "#58CC02",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.82031H14.5",
    stroke: "#58CC02",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81592 2.82422H3.82255M6.76329 2.82422H6.76992",
    stroke: "#58CC02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21784 10.0549C5.42205 10.0549 5.08089 10.5736 4.99247 10.8927C4.90405 11.2113 4.90405 12.3676 4.9571 12.8464C5.13395 13.4442 5.57605 13.6909 6.00932 13.7707C6.40721 13.8033 8.08721 13.7906 8.57353 13.7906C9.28089 13.8033 9.81142 13.5639 10.0325 12.8464C10.0767 12.607 10.1209 11.2904 10.0104 10.8921C9.77605 10.2537 9.23889 10.0549 8.79679 10.0549M6.21784 10.0549H8.79679M6.21784 10.0549C6.21784 10.015 6.21637 9.50563 6.21784 9.21704C6.21784 8.95239 6.19279 8.69837 6.33279 8.46563C6.85595 7.52604 8.3591 7.62113 8.73047 8.57868C8.79458 8.73627 8.799 8.98563 8.79679 9.21704C8.79458 9.51095 8.79679 10.0549 8.79679 10.0549",
    stroke: "#58CC02",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetType);
export default __webpack_public_path__ + "static/media/asset_type.98982d778e1d83f95bef65349fb8d51b.svg";
export { ForwardRef as ReactComponent };